<template>
  <v-card
    loader-height="8"
    :disabled="admin.subsystemsLoading"
    :loading="admin.subsystemsLoading"
    :min-height="minCardHeight"
    :class="transparent"
    rounded
    min-width="400"
  >
    <v-toolbar color="blue darken-2" class="text-h4 text-uppercase" dark>
      Subsystems
      <v-spacer></v-spacer>

      <v-icon>{{ app.subsystemIcon }}</v-icon>
    </v-toolbar>
    <v-card-text>
      <v-data-table
        @click:row="rowClick"
        @dblclick:row="showDialog"
        single-select
        show-select
        v-model="selectionModel"
        dense
        v-on:item-selected="updateSelection"
        :headers="subsystemListHeaders"
        :items="admin.subsystemList"
        :items-per-page="15"
      >
        <template v-slot:item.published="{ item }">
          <v-icon color="success" v-show="item.published">mdi-check</v-icon>
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        v-show="admin.selectedSystem != null"
        dark
        color="blue darken-2"
        @click="addNewSubsystem"
        ><v-icon>mdi-plus</v-icon> ADD NEW</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    props: {
      minCardHeight: Number
    },
    components: {},
    data() {
      return {
        subsystemListHeaders: [
          { text: 'ID', value: 'id', width: '80px' },
          { text: 'NAME', value: 'name' },
          { text: 'DESCRIPTION', value: 'description' },
          { text: 'SUBSYSTEM TYPE', value: 'subsystemType' },
          { text: 'USER TYPE', value: 'userType' },
          { text: 'PUBLISHED', value: 'published' }
        ]
      };
    },
    computed: {
      ...mapState(['app', 'admin']),
      transparent: {
        get() {
          return this.admin.selectedSystem ? '' : '';
        }
      },
      selectionModel: {
        get() {
          return this.admin.selectedSubsystemSelectionModel;
        },
        set(value) {
          this.$store.commit('admin/setSelectionModel', {
            entity: 'selectedSubsystemSelectionModel',
            value: value
          });
        }
      }
    },
    methods: {
      /**
       * Updates the dialog flag in state
       */
      showDialog: function () {
        this.$store.commit('admin/setShowEditSubsystemDialog', true);
      },
      /**
       * Handles row click
       */
      rowClick: function (item, row) {
        row.select(true);
      },
      /**
       * Adds new subsystem
       */
      addNewSubsystem() {
        this.$store.commit('admin/setSelectedSubsystem', {
          id: 'new',
          systemDefinitionId: this.admin.selectedSystem.id,
          name: '',
          description: '',
          subsystemType: '',
          published: false
        });
        // auto tab switch
        this.$store.commit(
          'admin/setCurrentSystemTab',
          this.admin.SYSTEM_TABS.SUBSYSTEM
        );
        this.$store.commit('admin/setShowEditSubsystemDialog', true);
        // clear selection models
        this.clearChildSelectionModels();
        this.clearThisSelectionModel();
        // clear child lists
        this.$store.commit('admin/setComponentList', []);
      },
      /**
       * Fires when an item is selected in the data table
       */
      updateSelection(data) {
        if (data.value) {
          this.$store.commit('admin/setSelectedSubsystem', data.item);
          this.$store.dispatch(
            'admin/getComponentsBySubsystemId',
            data.item.id
          );
          // auto tab switch
          this.$store.commit(
            'admin/setCurrentSystemTab',
            this.admin.SYSTEM_TABS.SUBSYSTEM
          );
        } else {
          this.$store.commit('admin/setSelectedSubsystem', null);
          this.$store.commit('admin/setComponentList', []);
          // auto tab switch
          //this.$store.commit("admin/setCurrentSystemTab", this.admin.SYSTEM_TABS.SYSTEM)
        }
        this.clearChildSelectionModels();
      },
      /**
       * Clears child selection models
       */
      clearChildSelectionModels() {
        this.$store.commit('admin/setSelectionModel', {
          entity: 'selectedComponentSelectionModel',
          value: null
        });
        this.$store.commit('admin/setComponentList', []);
      },
      /**
       * Clears this components selection model
       */
      clearThisSelectionModel() {
        this.$store.commit('admin/setSelectionModel', {
          entity: 'selectedSubsystemSelectionModel',
          value: null
        });
      }
    }
  };
</script>
